import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Divider,
    List,
    ListItem,
    ListItemText,
} from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import PostData from "../../services/PostData.js";

export default function CombineShipmentsDialog({
    isOpen,
    onClose,
    onSuccess,
    shipments = [],
}) {
    const [submitLoad, setSubmitLoad] = useState(false);
    const [successSubmit, setSuccessSubmit] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isOpen) {
            setSuccessSubmit(false);
            setErrorMessage("");
            setSubmitLoad(false);
        }
    }, [isOpen]);

    const handleConfirm = async () => {
        const shipmentIds = shipments.map((row) => row.id).filter(Boolean);
        if (shipmentIds.length < 2) return;
        setSubmitLoad(true);
        setErrorMessage("");
        const { success, error, data } = await PostData(
            { shipmentIds },
            "broylesllc/shipments/combine",
            null
        );
        setSubmitLoad(false);
        if (success) {
            setSuccessSubmit(true);
            setTimeout(() => {
                if (onSuccess) onSuccess(data);
                else onClose?.();
            }, 800);
            return;
        }
        const message =
            error?.response?.data?.message ||
            (typeof error?.response?.data === "string" ? error.response.data : "") ||
            error?.message ||
            "Could not combine these shipments.";
        setErrorMessage(String(message));
    };

    const orderLabels = shipments.map(
        (row) =>
            row.customerOrderNumber ||
            row.orderNumber ||
            row.itemId ||
            row.id ||
            "—"
    );

    return (
        <Dialog open={isOpen} onClose={submitLoad ? undefined : onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ padding: "10px 15px 5px 15px" }}>
                Combine Shipments
            </DialogTitle>
            <Divider sx={{ borderColor: "black" }} />
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    Pack these marketplace orders in one physical shipment. Each order
                    stays its own Shipping row; one label will push the same tracking to
                    every channel order.
                </Typography>
                <List dense sx={{ mt: 1, bgcolor: "#f8fafc", borderRadius: 1 }}>
                    {orderLabels.map((label, index) => (
                        <ListItem key={`${label}-${index}`} sx={{ py: 0.25 }}>
                            <ListItemText
                                primary={label}
                                primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }}
                            />
                        </ListItem>
                    ))}
                </List>
                <Typography variant="body2" sx={{ mt: 1.5, color: "text.secondary" }}>
                    Requirements: same buyer, same selling channel, same ship-to address,
                    and all Needs Label (void any existing UPS labels first).
                </Typography>
                {errorMessage ? (
                    <Typography color="error" sx={{ mt: 2, fontSize: 13 }}>
                        {errorMessage}
                    </Typography>
                ) : null}
            </DialogContent>
            <DialogActions sx={{ justifyContent: "space-between" }}>
                <Button onClick={onClose} color="primary" disabled={submitLoad}>
                    Close
                </Button>
                <Button
                    loading={submitLoad}
                    disabled={submitLoad || successSubmit || shipments.length < 2}
                    onClick={handleConfirm}
                    color="primary"
                    variant="contained"
                >
                    {successSubmit ? (
                        <>
                            <span>Success</span>
                            <CheckOutlinedIcon
                                fontSize="small"
                                sx={{ color: "white", marginLeft: "10px" }}
                            />
                        </>
                    ) : (
                        "Combine"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
